import _regeneratorRuntime from "/data/home/csserver/project/jiankao/jiankao_admin_h5/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/home/csserver/project/jiankao/jiankao_admin_h5/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import router from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login']; // no redirect whitelist

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var hasToken, hasGetUserInfo;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.next = 27;
            break;
          }
          if (!(to.path === '/login')) {
            _context.next = 9;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          NProgress.done();
          _context.next = 25;
          break;
        case 9:
          hasGetUserInfo = store.getters.name;
          if (!hasGetUserInfo) {
            _context.next = 14;
            break;
          }
          next();
          _context.next = 25;
          break;
        case 14:
          _context.prev = 14;
          // get user info todo 培楠: 获取用户信息,暂时没做
          // await store.dispatch('user/getInfo')

          next();
          _context.next = 25;
          break;
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](14);
          _context.next = 22;
          return store.dispatch('user/resetToken');
        case 22:
          Message.error(_context.t0 || 'Has Error');
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        case 25:
          _context.next = 28;
          break;
        case 27:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            NProgress.done();
          }
        case 28:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[14, 18]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});